import React, {useState, useEffect} from 'react';
import Select, { components } from 'components/common/AppSelect'
import GlobalState, {changeLoadSegmentation} from "../../stores/GlobalState";

import { observer } from 'mobx-react'
import './index.css';

import lang from "../../lang"
import Loading from '../common/loading';
const Models = observer(() => {
     const [textloading, setTextloadingdeploy] = useState("Loading powerbi in progress ");
    useEffect(()=>{changeLoadSegmentation(0)},[])
    return (
        GlobalState.loadsegmentations==1?
        <div style={{marginTop:'calc(50vh - 75px)'}}>
            <Loading text = {textloading}/>
        </div>
        
        :
        <>
            <div className='models_block_frame' style={{paddingTop:"20px"}}>
                <iframe title="GevGur_Efficiency"  width="1840" height="920" src="https://app.powerbi.com/reportEmbed?reportId=83da120a-0c59-4b70-8717-bb4332577df4&autoAuth=true&ctid=0519402e-60e0-44a8-a81e-64843074bd9b" frameborder="0" allowFullScreen="true"></iframe>
            </div>
        </>
    );
})

export default Models;
